import type { HullPaintsFilters, HullPaintsVessel } from "../models/hull-paints.models";
import { getHullPaintsFilterOptions } from "../utils/hull-paints-filter.utils";
import HullPaintsFilterSelect from "./HullPaintsFilterSelect";
import { FunnelIcon } from "@heroicons/react/24/outline";

interface HullPaintsFilterPanelProps {
  filters: HullPaintsFilters;
  vessels: HullPaintsVessel[];
  onChange: (filters: HullPaintsFilters) => void;
  onClear: () => void;
}

const HullPaintsFilterPanel = ({ filters, vessels, onChange, onClear }: HullPaintsFilterPanelProps) => {
  const update = (key: keyof HullPaintsFilters, values: string[]) => onChange({ ...filters, [key]: values });
  const fields: Array<{ key: keyof HullPaintsFilters; label: string }> = [
    { key: "vesselName", label: "Vessel name" },
    { key: "imoNumber", label: "IMO" },
    { key: "yard", label: "Yard" },
    { key: "design", label: "Design" },
    { key: "contractType", label: "Contract type" },
    { key: "desk", label: "Desk" },
    { key: "builtYear", label: "Vessel built" },
    { key: "deliveryYear", label: "Delivery" },
    { key: "redeliveryYear", label: "Redelivery" },
  ];

  return (
    <div data-test="hull-paints-filter-panel">
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
        <div className="flex items-center gap-2">
          <FunnelIcon className="h-5 w-5 text-green" aria-hidden="true" />
          <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-100">Filter pane</h2>
        </div>
        <button
          type="button"
          onClick={onClear}
          className="text-[11px] font-semibold text-green hover:underline"
          data-test="hull-paints-clear-filters"
        >
          Clear filters
        </button>
      </div>
      <div className="grid gap-3 p-4 sm:grid-cols-2 lg:grid-cols-1">
        {fields.map((field) => (
          <HullPaintsFilterSelect
            key={field.key}
            label={field.label}
            selectedValues={filters[field.key]}
            options={getHullPaintsFilterOptions(vessels, filters, field.key)}
            onChange={(values) => update(field.key, values)}
            testId={`hull-paints-filter-${field.key}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HullPaintsFilterPanel;
